<phx-select
    [items]="shopListArray()"
    [formControl]="formControl"
    [formlyAttributes]="field"
    bindLabel="label"
    bindValue="value"
    [dataTestId]="props.dataTestId"
>
</phx-select>
